import { Component, h, Host, Prop } from "@stencil/core";

export type LoaderVariant = "light" | "dark";

@Component({
    tag: "uic-loader",
    styleUrl: "loader.scss"
})
export class Loader {
    /**
     * The variant to use. Use the "light" variant on dark backgrounds
     */
    @Prop() readonly variant: LoaderVariant = "dark";

    render() {
        return (
            <Host class='uic-loader'>
                <div
                    class={{
                        "uic-loader__bar": true,
                        [`uic-loader--${this.variant}`]: true
                    }}
                ></div>
            </Host>
        );
    }
}
